import { render } from "./TransactionHistoryList.vue?vue&type=template&id=3c52c016&scoped=true"
import script from "./TransactionHistoryList.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryList.vue?vue&type=script&lang=js"

import "./TransactionHistoryList.vue?vue&type=style&index=0&id=3c52c016&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c52c016"]])

export default __exports__